export default __webpack_public_path__ + "static/media/corn-icon.a7162541.svg";